import React from 'react';
import PropTypes from 'prop-types';
import GenericError from './GenericError';
import NavigationHistory from '../../libs/NavigationHistory';

/**
 * Show the server state errors on the event list.
 */

const EventlistError = (props) => {
  const { errorCode, navigationHistory } = props;
  return (
    <GenericError
      navigationHistory={navigationHistory}
      errorCode={errorCode}
      message401={i18n('You are not allowed to view these events.')}
      message403={i18n('You are not allowed to view these events.')}
      message404={i18n('These events could not be found.')}
    />
  );
};

EventlistError.propTypes = {
  errorCode: PropTypes.oneOf(['', 400, 401, 403, 404, 429, 502, 503]),
  navigationHistory: PropTypes.instanceOf(NavigationHistory).isRequired
};

export default EventlistError;
